module.exports = __webpack_public_path__ + "img/servicioInspecAccidente.4ff95eed.jpg";